/* ============================================================
   DUSK & RELIC — Meta Pixel · storefront event layer
   Loaded by snippets/dnr-meta-pixel.liquid (deferred).

   Fires:
     ViewContent   product page
     ViewCategory  collection page
     Search        search results page
     AddToCart     any /cart/add — intercepted at the network layer, so it
                   works for the PDP form, the cart drawer, quick-add and
                   anything added later, without touching those files
     Lead          newsletter signup (footer join panel)

   NOT fired here — they live in the customer-events pixel because checkout
   pages are not rendered by the theme:
     InitiateCheckout · AddPaymentInfo · Purchase

   Every event carries an eventID (see the snippet) so the same events can be
   mirrored server-side via the Conversions API later without double counting.
   ============================================================ */
(function () {
  var CFG = window.DNRMeta;
  if (!CFG || typeof CFG.track !== 'function') return;

  var CUR = CFG.currency || 'USD';
  var FMT = CFG.idFormat || 'variant';

  function money(cents) {
    return Math.round((Number(cents) || 0)) / 100;
  }

  function contentIdFor(item) {
    if (FMT === 'product') return item.product_id;
    if (FMT === 'sku') return item.sku || item.variant_id || item.id;
    return item.variant_id || item.id;
  }

  /* ---------- page-level events ---------- */

  if (CFG.pageType === 'product' && CFG.product) {
    var p = CFG.product;
    CFG.track('ViewContent', {
      content_ids: [String(p.contentId)],
      content_type: 'product',
      content_name: p.name,
      content_category: p.category,
      value: money(p.priceCents),
      currency: CUR,
      contents: [{ id: String(p.contentId), quantity: 1, item_price: money(p.priceCents) }]
    });
  }

  if (CFG.pageType === 'collection' && CFG.collection) {
    var c = CFG.collection;
    CFG.track('ViewCategory', {
      content_type: 'product',
      content_category: c.name,
      content_ids: (c.contentIds || []).map(String),
      currency: CUR
    });
  }

  if (CFG.pageType === 'search' && CFG.search) {
    var s = CFG.search;
    CFG.track('Search', {
      search_string: s.terms || '',
      content_type: 'product',
      content_ids: (s.contentIds || []).map(String),
      currency: CUR
    });
  }

  /* ---------- AddToCart — network interceptor ---------- */

  function isCartAdd(url) {
    var path = String(url || '').split('?')[0];
    return /\/cart\/add(\.js)?$/.test(path);
  }

  function trackAdd(data) {
    if (!data) return;
    var items = data.items && data.items.length ? data.items : data.id ? [data] : [];
    if (!items.length) return;

    var ids = [];
    var contents = [];
    var value = 0;

    items.forEach(function (it) {
      var qty = Number(it.quantity) || 1;
      var unit = it.final_price != null ? it.final_price : it.price;
      var line = it.final_line_price != null ? it.final_line_price : (Number(unit) || 0) * qty;
      var cid = String(contentIdFor(it));
      ids.push(cid);
      contents.push({ id: cid, quantity: qty, item_price: money(unit) });
      value += money(line);
    });

    CFG.track('AddToCart', {
      content_ids: ids,
      content_type: 'product',
      content_name: items[0].product_title || items[0].title,
      contents: contents,
      value: Math.round(value * 100) / 100,
      currency: (data.currency || CUR)
    });
  }

  /* fetch — the path Dawn and every dnr-* script uses */
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var promise = origFetch.apply(this, arguments);
      if (!isCartAdd(url)) return promise;
      return promise.then(function (res) {
        try {
          if (res && res.ok && typeof res.clone === 'function') {
            res
              .clone()
              .json()
              .then(trackAdd)
              .catch(function () {});
          }
        } catch (e) {}
        return res;
      });
    };
  }

  /* XMLHttpRequest — apps and older snippets still use it */
  (function () {
    var XHR = window.XMLHttpRequest;
    if (!XHR || !XHR.prototype) return;
    var open = XHR.prototype.open;
    XHR.prototype.open = function (method, url) {
      this.__dnrCartAdd = isCartAdd(url);
      return open.apply(this, arguments);
    };
    var send = XHR.prototype.send;
    XHR.prototype.send = function () {
      if (this.__dnrCartAdd) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            trackAdd(JSON.parse(this.responseText));
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  })();

  /* ---------- Lead — newsletter signup ---------- */

  function trackLead(source) {
    CFG.track('Lead', { content_name: source || 'Newsletter', content_category: 'Email list', currency: CUR });
  }

  /* The footer join panel is a native {% form 'customer' %}: Shopify reloads
     the page with ?customer_posted=true only when the signup actually
     succeeded. That reload is the single source of truth — we deliberately do
     NOT also listen for `submit`, which would double count. sessionStorage
     keeps a manual refresh of that URL from refiring. */
  try {
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var key = 'dnr:meta:lead:' + window.location.pathname;
      if (window.sessionStorage.getItem(key) !== '1') {
        window.sessionStorage.setItem(key, '1');
        trackLead('Newsletter');
      }
    }
  } catch (e) {}
})();
